import { Stack } from "@mui/material";
import ModelViewPage from "components/ui/customs/generics/ModelViewPage";
import { CaptableMultiFundWidget } from "../modelComponents/CaptableWidget";

const CaptableViewPage = ({ modelName, data }) => {
  return (
    <Stack sx={{ maxWidth: "600px", mx: "auto" }} spacing={2}>
      <CaptableMultiFundWidget captable={data} />
      <ModelViewPage modelName={modelName} data={data} />
    </Stack>
  );
};

export default CaptableViewPage;
